import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';
import ContactsContent from '../components/Contacts/ContactsContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const Contacts = () => {
    const {t} = useTranslation()

    const language = useSelector(selectLanguage)

    useEffect(() => {
        document.title = t('contacts-page.contacts-page-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])

  return (
    <>
        <NavbarTop/>
        <ContactsContent/>
    </>
  )
}

export default Contacts